<template>
  <div>
    <el-form size="mini" :model="para" label-width="80px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="记录名称">
            <el-input v-model="para.RecordName" placeholder="请输入内容模糊检索"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="任务名称">
            <el-select
              v-model="para.TaskIds"
              multiple
              style="width: 100%;"
              filterable
              clearable
              placeholder="请选择任务名称"
            >
              <el-option
                v-for="item in taskList"
                :key="item.RELATIONID"
                :label="item.RELATIONNAME"
                :value="item.RELATIONID"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="创建人">
            <el-select
              v-model="para.CreateUsers"
              multiple
              style="width: 100%;"
              clearable
              placeholder="请选择创建人"
            >
              <el-option
                v-for="item in createUserList"
                :key="item.ID"
                :label="item.NAME"
                :value="item.ID"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="重要级别">
            <el-rate :max="3" @change="changeDegree" style="margin-top: 5px;" v-model="para.Degree"></el-rate>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="border-bottom: 1px dashed lightgray; margin-bottom:10px">
        <el-col :span="6">
          <el-form-item label="排序方式">
            <el-select v-model="para.OrderIndex" style="width: 100%;" placeholder="请选择排序方式">
              <el-option
                v-for="item in orderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建时间">
            <div>
              <el-date-picker
                v-model="para.CreatetimeRange"
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                class="datePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
              <div class="timeRange-div">
                <el-radio-group v-model="createtimeRadio" class="timeRange-top">
                  <el-radio @click.native.prevent="createclickitem(1)" :label="1">最近七天</el-radio>
                  <el-radio @click.native.prevent="createclickitem(2)" :label="2">最近一月</el-radio>
                  <el-radio @click.native.prevent="createclickitem(3)" :label="3">
                    <div class="timeRange-bottom">
                      最近
                      <el-input class="inputtime" v-model="createtimeInput" size="mini"></el-input>
                      <el-select
                        class="searchTime"
                        size="mini"
                        v-model="createTimeDynamic"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in timeOptions"
                          style="margin-left:2px"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button @click="clear">清空</el-button>
            <el-button type="primary" @click="searchRecord">确 定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import searchJs from "@/util/search";
export default {
  props: {
    source: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    source(newSource) {
      if (newSource) {
        console.log("watch", newSource);
        this.taskList = [];
        this.createUserList = [];
        this.filterSource = [...newSource];
        this.searchRecord();
        newSource.forEach(o => {
          o.Relations.forEach(r => {
            if (!this.taskList.some(s => s.RELATIONID == r.RELATIONID)) {
              this.taskList.push(r);
            }
          });
          if (!this.createUserList.some(s => s.ID === o.CREATEUSERID)) {
            this.createUserList.push({
              NAME: o.CREATEUSERNAME,
              ID: o.CREATEUSERID
            });
          }
        });
      }
    }
  },
  data() {
    return {
      para: {
        RecordName: "",
        TaskIds: [],
        Degree: "",
        OrderIndex: 0,
        CreateUsers: [],
        CreateTimeRange: []
      },
      degree: 0,
      filterSource: [],
      createUserList: [],
      taskList: [],
      orderList: [
        {
          label: "创建时间-降序",
          value: 0
        },
        {
          label: "创建时间-升序",
          value: 1
        },
        {
          label: "重要等级",
          value: 2
        },
        {
          label: "任务名称",
          value: 3
        },
        {
          label: "创建人",
          value: 4
        }
      ],
      createtimeRadio: 1, //创建时间选择
      createtimeInput: "", //创建时间填写
      createTimeDynamic: 1, //创建时间（小时,天，周，月）
      timeOptions: [
        {
          label: "小时",
          value: 1
        },
        {
          label: "天",
          value: 2
        },
        {
          label: "周",
          value: 3
        },
        {
          label: "月",
          value: 4
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    changeDegree(val) {
      if (this.degree == val && val != 0) {
        this.para.Degree = 0;
        this.degree = 0;
      } else {
        this.degree = val;
      }
    },
    clear() {
      this.para = {
        RecordName: "",
        TaskIds: [],
        Degree: "",
        OrderIndex: 0,
        CreateUsers: [],
        CreateTimeRange: []
      };

      this.filterSource = [...this.source];
      this.filterSource.sort((a, b) => a.CREATETIME > b.CREATETIME);
      let timeRange = searchJs.timeDisposal(
        this.para.CreatetimeRange,
        this.createtimeRadio,
        this.createtimeInput,
        this.createTimeDynamic
      );
      if (timeRange) {
        if (timeRange.length === 2) {
          let createTime1 = timeRange[0];
          let createTime2 = timeRange[1];
          this.filterSource = this.filterSource.filter(
            o => o.CREATETIME > createTime1 && o.CREATETIME < createTime2
          );
        }
      }
      this.createtimeRadio = 1; //创建时间选择
      this.createtimeInput = ""; //创建时间填写
      this.createTimeDynamic = 1; //创建时间（小时,天，周，月）
      this.$emit("getFilterSource", this.filterSource);
    },
    createclickitem(e) {
      e === this.createtimeRadio
        ? (this.createtimeRadio = 0)
        : (this.createtimeRadio = e);
    },
    searchRecord() {
      this.filterSource = [...this.source];
      let timeRange = searchJs.timeDisposal(
        this.para.CreatetimeRange,
        this.createtimeRadio,
        this.createtimeInput,
        this.createTimeDynamic
      );
      if (timeRange) {
        if (timeRange.length === 2) {
          let createTime1 = timeRange[0];
          let createTime2 = timeRange[1];
          this.filterSource = this.filterSource.filter(
            o => o.CREATETIME > createTime1 && o.CREATETIME < createTime2
          );
        }
      }
      if (this.para.CreateUsers.length > 0) {
        this.filterSource = this.filterSource.filter(o =>
          this.para.CreateUsers.some(p => p == o.CREATEUSERID)
        );
      }
      if (this.para.Degree) {
        this.filterSource = this.filterSource.filter(
          o => o.DEGREE == this.para.Degree
        );
      }
      if (this.para.TaskIds.length > 0) {
        this.filterSource = this.filterSource.filter(o =>
          this.para.TaskIds.some(p => o.Relations.some(s => s.RELATIONID == p))
        );
      }
      if (this.para.RecordName) {
        this.filterSource = this.filterSource.filter(o =>
          o.NAME.includes(this.para.RecordName)
        );
      }

      switch (this.para.OrderIndex) {
        case 0:
          this.filterSource.sort((a, b) => {
            return a.CREATETIME > b.CREATETIME ? -1 : 1;
          });
          break;
        case 1:
          this.filterSource.sort((a, b) => {
            return a.CREATETIME > b.CREATETIME ? 1 : -1;
          });
          break;
        case 2:
          this.filterSource.sort((a, b) => b.DEGREE - a.DEGREE);
          break;
        case 3:
          this.filterSource.sort(
            (a, b) => a.TASKNAME.length - b.TASKNAME.length
          );
          break;
        case 4:
          this.filterSource.sort((a, b) => a.CREATEUSERID - b.CREATEUSERID);
          break;
      }
      console.log("getFilterSource", this.filterSource);
      this.$emit("getFilterSource", this.filterSource);
    }
  }
};
</script>

<style lang="scss" scoped>
.timeRange-div {
  margin-top: 5px;
  display: flex;
  align-items: center;
}

.timeRange-top {
  width: 70%;
  display: flex;
}

.timeRange-bottom {
  display: inline-block !important;
  margin-left: 5px;
  width: 30%;
  display: flex;
}

.searchTime {
  width: 80px;
}
</style>
